import type { ActionTimingChoice } from "./api-client.service";

export type QuickAddPriority = "low" | "medium" | "high";
export type QuickAddRecurrence = "none" | "daily" | "weekly" | "monthly";

export interface QuickAddTimingPayload {
  readonly dueDate?: string;
  readonly lockedDay?: string;
  readonly lockedAt?: string;
  readonly manualTime?: string;
}

export interface QuickAddPayload extends QuickAddTimingPayload {
  readonly userTime?: ActionTimingChoice;
  readonly userPriority: QuickAddPriority;
  readonly recurrence: QuickAddRecurrence;
}

export function buildQuickAddPayload(input: {
  readonly timing?: ActionTimingChoice | null;
  readonly priority: QuickAddPriority;
  readonly recurrence: QuickAddRecurrence;
  readonly timingPayload?: QuickAddTimingPayload;
}): QuickAddPayload {
  const base: QuickAddPayload = { userPriority: input.priority, recurrence: input.recurrence };
  if (!input.timing) return base;
  return { ...base, ...(input.timingPayload ?? {}), userTime: input.timing };
}
